import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  IBank,
  IViewResendTxWebhookDetails,
  IViewTransaction,
  NoMeta,
} from "../../../interfaces-and-types";
import {
  useBanks,
  useMerchantApiMutation,
  useMerchantApiQueryWithParams,
  useReactRouterLink,
} from "../../../hooks";
import { View } from "./View";
import { appConstants } from "../../../constants";

export interface IPaymentDetailsModalViewProps {
  isLoading: boolean;
  isError: boolean;
  isModalOpen: boolean;
  closeModal: () => void;
  modalData: IViewTransaction | null;
  resolvedBankNameFromBankCode?: string | null;
  resendTxWebhook: () => void;
  customerPaymentsSearchQuery?: string | null;
  enableSearchCustomerPayments: boolean;
}

export const PaymentDetailsModal = () => {
  const { location, navigateToRoutePreserveParams } = useReactRouterLink();

  const [isFirstNavToDetails, setFirstNavToDetails] = useState(true);

  const closeModal = () => {
    // simply go back if already on the payments page
    // if (location.pathname.indexOf("payments") >= -1) navigate(-1);
    // else navigate("/payments");

    // if (isFirstNavToDetails) navigate(-1);

    navigateToRoutePreserveParams(
      location.pathname.replace(`${id}/details`, "")
    );
  };

  const { id } = useParams();

  useEffect(() => {
    setFirstNavToDetails(false);
  }, [id]);

  const {
    isLoading: isLoadingTransactionDetails,
    isSuccess: isSuccessTransactionDetails,
    isError: isErrorTransactionDetails,
    data: transaction,
  } = useMerchantApiQueryWithParams<{ id: string }, IViewTransaction>(
    [
      "getTransactionById",
      {
        id: id!, // NOTE: use this to ensure that react query caches with the correct queryKey
      },
    ],
    {
      enabled: !!id,
    },
    (urlTemplate) => urlTemplate.replace("id", id!)
  );

  const {
    // isLoading,
    // isSuccess,
    // isError,
    data: bankAccountDetailsApiResponse,
    mutate: resendTxWebhook,
  } = useMerchantApiMutation<null, IViewResendTxWebhookDetails>(
    "resendTxWebhookById",
    ["getTransactionById"],
    {
      // ignoreActivityBlocker: true,
    },
    (templateQueryUrl) => `${templateQueryUrl}/${id}`
  ).usePostMutation;

  const bankListContext = useBanks();
  const resolvedBankNameFromBankCode = bankListContext.data?.find(
    (bnk) => bnk.bank_code === transaction?.bank_trsf_bank_code
  );

  return (
    <View
      isLoading={isLoadingTransactionDetails}
      isError={isErrorTransactionDetails}
      isModalOpen={!!id}
      closeModal={closeModal}
      resendTxWebhook={() => resendTxWebhook(null)}
      modalData={transaction || null}
      resolvedBankNameFromBankCode={resolvedBankNameFromBankCode?.bank_name}
      customerPaymentsSearchQuery={transaction?.customer.email}
      enableSearchCustomerPayments={isSuccessTransactionDetails}
    />
  );
};
